export const BLANK_TEMPLATE_DOCUMENT_ID = '2dd00095-350d-41e3-8997-5af977b6a6b2';
//# sourceMappingURL=documentIds.js.map